<template>
  <el-table-column
    v-bind="$attrs"
    :label="label"
    align="center"
    class-name="amount-field"
  >
    <template slot-scope="scope">
      <el-popover
        trigger="hover">
        <el-table
          :data="getData(scope.row)"
          :span-method="cellMerge"
          :show-header="false"
          row-class-name="popover-field"
        >
          <el-table-column
            prop="symbol"
            align="right"
            width="20"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            align="center"
            width="160"
          >
          </el-table-column>
          <el-table-column
            prop="amount"
            align="right"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="currency"
            align="center"
          >
          </el-table-column>
        </el-table>
        <el-button circle slot="reference">
          <svg-icon icon-class="baseline-attach_money-24px"></svg-icon>
        </el-button>
      </el-popover>
    </template>
  </el-table-column>
</template>

<script>

import { addCommas } from '@/utils/number'
import { getTransText } from '@/utils/i18n'

export default {
  name: 'orders-amount',
  props: {
    value: null,
    base: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isTxnSuccess: false
    }
  },
  computed: {
    label () {
      return this.getTransText(this.name, 'label', this.base)
    }
  },
  methods: {
    addCommas,
    getTransText,
    getRate (fncRate) {
      if (fncRate <= 0) {
        fncRate = 1
      }
      return parseFloat((1 / fncRate).toFixed(4))
    },
    getBonus (data) {
      var rate = this.getRate(data['fnc_rate'])
      return this.addCommas(data['bonus'] * rate)
    },
    getBonusCurrency (data) {
      var rate = this.getRate(data['fnc_rate'])
      if (data['bonus'] > 0 && rate !== 1) {
        return '(' + this.addCommas(data['bonus']) +
          ' x ' + rate + ')'
      }
      return ''
    },
    cellMerge ({ row, column, rowIndex, columnIndex }) {
      if (row.amount === '' && columnIndex === 1) {
        return {
          rowspan: 1,
          colspan: 3
        }
      }
    },
    getName (name) {
      return this.$t('api.orders.fields.' + name + '.label')
    },
    getTotalAmountName (isPenaltyTxnExists) {
      let name = this.getName('total_amount')

      if (isPenaltyTxnExists) {
        name += this.$t('api.orders.fields.total_amount.penalty')
      }

      return name
    },
    getData (data) {
      let totalAmount = data['payment_set_orders_amount'] || data['orders_amount'] || data['total_amount']
      let arr = [{
        symbol: '',
        name: this.getTotalAmountName(data['is_penalty_txn_exists']),
        amount: this.addCommas(totalAmount)
      }, {
        symbol: '-',
        name: this.getName('bonus'),
        amount: this.getBonus(data),
        currency: this.getBonusCurrency(data)
      }, {
        symbol: '-',
        name: this.getName('discount'),
        amount: this.addCommas(data['discount'])
      }]
      if (data['discount_mode'] && data['discount_mode'] === 2) {
        arr.push({
          symbol: '-',
          name: this.getName('yc_discount'),
          amount: (data['discount_type'] === 1)
            ? this.addCommas(data['discount_value']) : data['discount_value'] + '%'
        })
      }
      let fee = []
      if (data['orders_delivery_id']) {
        fee = [{
          symbol: '+',
          name: this.getName('delivery_fee'),
          amount: this.addCommas(data['delivery_fee'])
        }]
      }
      let total = [{
        symbol: '=',
        name: this.getName('txn_amount'),
        amount: this.addCommas(data['payment_set_txn_amount'] || data['txn_amount']),
        currency: data['currency_code']
      }]
      let txn = [{
        symbol: '=',
        name: this.getName('txn_pay_amount'),
        amount: this.addCommas(data['payment_set_txn_pay_amount'] || data['txn_pay_amount']),
        currency: data['txn_currency_code']
      }]
      if (data['txn_status'] !== undefined && data['txn_status'] !== 1) {
        txn = [{
          name: this.$t('api.orders.txn_none'),
          amount: ''
        }]
      }
      // refund amount
      if (typeof data['refund_type'] !== 'undefined') {
        txn = [{
          symbol: '=',
          name: this.getName('txn_pay_amount'),
          amount: this.addCommas(data['txn_pay_amount']),
          currency: data['txn_currency_code']
        }, {
          symbol: '-',
          name: this.$t('api.refund.fields.total_amount.label'),
          amount: this.addCommas(data['total_amount']),
          currency: data['txn_currency_code']
        }]
      }
      if (typeof data['invoice_date'] !== 'undefined') {
        txn = [{
          symbol: '=',
          name: this.$t('api.invoice.fields.sales_amount.label'),
          amount: this.addCommas(data['sales_amount']),
          currency: data['currency_code']
        }]
      }
      return arr.concat(fee, total, txn)
    }
  }
}
</script>
